import { useEffect, useState } from 'react';
import SelectInput from '../../../../components/Basic/Inputs/SelectWithInput';
import ProviderCommonApi from '../../../../API/provider/common-api';

export default function ProductCategorySelect({
  category = '',
  onChange = () => { },
  isAllCategotries = true,
  style,
  label = '',
  searchParams = {},
  ...props
}) {
  const [list, setList] = useState([]);
  const [value, setValue] = useState('');
  const [isOk, setIsOk] = useState(null);

  const findCategory = (search) => {
    ProviderCommonApi.getCategories({ data: { search, ...searchParams } }).then((r) => {
      const categories = r.categories;
      setList(categories);
      if (r.matchedCategory) {
        setIsOk(true);
      } else {
        setIsOk(false);
      }
    });
  };

  const onSelect = (v) => {
    // setValue(v);
    onChange(v);
    setIsOk(null);
  };

  const onBlur = () => {
    if (isOk) {
      onSelect(value);
      //setIsOk(null);
    }
  };

  const deleteCategory = () => {
    onChange('');
    setIsOk(null);
  };

  useEffect(() => {
    setValue(category);
  }, [category]);

  const onChangeInput = (v) => {
    if (v.length === 0) {
      //onChange('');
    }
    setValue(v);
    findCategory(v || '');
  };

  return (
    <SelectInput
      label={label}
      select={value}
      list={list}
      add={false}
      width={"300px"}
      preventState={true}
      addText={'Добавить'}
      defaultText={'Без категории'}
      placeholder={'Категория товара'}
      {...props}
      isOk={isOk}
      onBlur={onBlur}
      onChange={onChangeInput}
      onSelect={onSelect}
      deletePlace={deleteCategory}
      onFocus={(v) => findCategory(v || '')}
    />
  );
}
